import { lazy } from 'react';

// project-imports
import GuestGuard from 'utils/route-guard/GuestGuard';
import CommonLayout from 'layout/CommonLayout';
import Loadable from 'components/Loadable';

// render - login
const AuthLogin = Loadable(lazy(() => import('pages/auth/auth1/login')));
const AuthRegister = Loadable(lazy(() => import('pages/auth/auth1/register')));
const AuthForgotPassword = Loadable(lazy(() => import('pages/auth/auth1/forgot-password')));
const AuthCheckMail = Loadable(lazy(() => import('pages/auth/auth1/check-mail')));
const AuthResetPassword = Loadable(lazy(() => import('pages/auth/auth1/reset-password')));
const AuthCodeVerification = Loadable(lazy(() => import('pages/auth/auth1/code-verification')));
// const InvoiceDetails = Loadable(lazy(() => import('pages/invoices/customerInvoiceDetails')));
const InvoiceDownload = Loadable(lazy(() => import('pages/invoices/customerInvoiceDownload')));
const ReceiptVoucherDownload = Loadable(lazy(() => import('pages/invoices/customerReceiptVoucherDownload')));

// ==============================|| AUTH ROUTES ||============================== //

const LoginRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element: (
        <GuestGuard>
          <CommonLayout />
        </GuestGuard>
      ),
      children: [
        {
          path: '/',
          element: <AuthLogin />
        },
        {
          path: 'login',
          element: <AuthLogin />
        },
        {
          path: 'register',
          element: <AuthRegister />
        },
        {
          path: 'forgot-password',
          element: <AuthForgotPassword />
        },
        {
          path: 'check-mail',
          element: <AuthCheckMail />
        },
        {
          path: 'reset-password',
          element: <AuthResetPassword />
        },
        {
          path: 'code-verification',
          element: <AuthCodeVerification />
        },
        // {
        //   path: 'invoice/:id',
        //   element: <InvoiceDetails />
        // },
        {
          path: 'invoice/:id',
          element: <InvoiceDownload />
        },
        {
          path: 'receipt-voucher-download/:id',
          element: <ReceiptVoucherDownload />
        }
      ]
    }
  ]
};

export default LoginRoutes;
